import { Model } from 'app/model/backendmodel';
import { AdapterRegistry } from 'shell-models-lib';
import { SharePointOnlineListResourceDataset } from 'app/model/dataset/sharepoint-online-list-resource.dataset';
import { Metamodel } from 'app/model/base/model';
import { TabularTypeDatasetAdapter } from './tabular-type.dataset.adapter';

@AdapterRegistry.adapter({
    model: Metamodel.modelFor(SharePointOnlineListResourceDataset),
    asynchronous: true,
    adapts: {
        name: '*',
        properties: {
            description: '*',
            folder: '*',
            annotations: '*',
            schema: '*',
            linkedServiceName: '*',
            parameters: '*',
            type: '*',
            typeProperties: {
                listName: '*'
            }
        }
    }
})
export class SharePointOnlineListResourceDatasetAdapter extends TabularTypeDatasetAdapter<SharePointOnlineListResourceDataset, Model.DatasetResource> {
    protected async _toResource(dataset: SharePointOnlineListResourceDataset): Promise<Model.DatasetResource> {
        return await this._toResourceInternal(dataset, Metamodel.modelFor(SharePointOnlineListResourceDataset).name, 'listName');
    }

    protected async _toModel(modelDatasetResource: Model.DatasetResource, dataset?: SharePointOnlineListResourceDataset): Promise<SharePointOnlineListResourceDataset> {
        return await this._toModelInternal(modelDatasetResource, dataset,  SharePointOnlineListResourceDataset.MODEL, 'listName');
    }
}
